/**
 * Created by kldavis on 2/23/17.
 */
var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Classes.DynamicScriptLoaderAsyncJob = new Class({
    Extends: OCS.Classes.DynamicScriptLoaderJob,
    options: {
        'classname': "OCS.Classes.DynamicScriptLoaderAsyncJob"
    },
    get_loader_run: function (run_ops) {
        return new OCS.Classes.DynamicScriptLoaderAsyncRun(run_ops);
    }
});